import styled from "styled-components";

import { flexColumn, rem } from "@styles/Utilities.styled";


export const StyledSlotTemplates = styled.div`
  ${flexColumn}
  width: 100%;
  gap: ${rem(32)};
  padding-bottom: ${rem(100)};

  .header {
    h1 {
      font-size: ${rem(20)};
      font-weight: 500;
    }
  }
`;
